import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
	MobileDataList,
	MobileListCard,
	MobileListCardHeader,
	MobileListDetailRow,
} from '../../../Components/MobileDataList';

const CustomerListCard = ({ customer, onEdit, onDelete }) => (
	<MobileListCard>
		<Stack spacing={1.5}>
			<MobileListCardHeader title={customer.name} />

			<Stack spacing={1}>
				<MobileListDetailRow label="Phone" value={customer.phone} />
				<MobileListDetailRow label="Email" value={customer.email} />
				<MobileListDetailRow
					label="Invoicing email"
					value={customer.invoicing_email}
				/>
			</Stack>

			<Stack direction="row" spacing={0.5} justifyContent="flex-end">
				<Tooltip title="Edit">
					<IconButton size="small" onClick={() => onEdit(customer)}>
						<EditIcon fontSize="small" />
					</IconButton>
				</Tooltip>
				<Tooltip title="Delete">
					<IconButton
						size="small"
						color="error"
						onClick={() => onDelete(customer.id)}
					>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			</Stack>
		</Stack>
	</MobileListCard>
);

const CustomersMobileList = ({ customers, isLoading, onEdit, onDelete }) => (
	<MobileDataList
		items={customers}
		isLoading={isLoading}
		getKey={(customer) => customer.id}
		emptyTitle="No customers yet"
		emptyDescription="Create a customer to attach them to jobs and invoices."
		renderItem={(customer) => (
			<CustomerListCard
				customer={customer}
				onEdit={onEdit}
				onDelete={onDelete}
			/>
		)}
	/>
);

export default CustomersMobileList;
